import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import getAuthorizationUrl from '../../helpers/getAuthorizationUrl';
const TinyFrame = styled.iframe `
  display: none;
  z-index: -1;
  height: 0;
  width: 0;
`;
/**
 * @example
 *  <HiddenFrame
 *    baseURL={'https://auth-qa.syfbank.com'}
 *    clientId={GET_THIS_FROM_DEV_PORTAL}
 *    redirectURI={'${window.location.origin}/callback'}
 *    loginHintURL={'https://dev-pcf.synchronycredit.com/login/lowes/?client=lowes'}
 *   />
 * @param baseUrl the environment of the auth api
 * @param clientId id of client, usually gained from dev portal
 * @param redirectURI where the auth site will set the url once complete
 * @param loginHintURL
 *
 * @returns a hidden iFrame component
 */
export const HiddenFrame = ({ baseURL, clientId, redirectURI, loginHintURL }) => {
    const sourceURL = getAuthorizationUrl({
        baseURL,
        clientId,
        redirectURI,
        loginHintURL
    });
    return (_jsx(TinyFrame, { title: "Intentionally Blank", "aria-hidden": true, id: "hidden-iframe", src: sourceURL, 
        /**
         * Sandbox restricts the iframe content except for the methods stated
         * allow-scripts = lets the iframe run scripts
         * allow-same-origin = tell the iframe to treat its content as being from same origin as parent window
         */
        sandbox: "allow-scripts allow-same-origin" }));
};
export default HiddenFrame;
